import { memo, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { trackMetaPixelEvent, trackMetaPixelPageView } from '../../../catalog/MetaPixel';
import { isOrdersPath } from '../../../catalog/FanOrders';
import { trackAppLovinEvent, trackAppLovinPageView } from '../../../catalog/AppLovinPixel';

// Set while we strip the checkout=success param so the resulting history
// replace does not double-count a page view for the same page.
let suppressNextPageView = false;

const checkCheckoutSuccess = (history, location) => {
    const params = new URLSearchParams(location.search);
    if (params.get('checkout') === 'success') {
        // Meta flags Subscribe events missing a positive value + currency.
        const value = parseFloat(params.get('value'));
        const currency = params.get('currency');
        const valueParams = (value > 0 && currency) ? { value, currency } : undefined;
        trackMetaPixelEvent('Subscribe', valueParams);
        trackAppLovinEvent('subscribe', valueParams);
        params.delete('checkout');
        params.delete('value');
        params.delete('currency');
        suppressNextPageView = true;
        history.replace({ pathname: location.pathname, search: params.toString() });
    }
};

/**
 * Fires Meta Pixel and AppLovin Axon page views on every client-side route
 * change (the base pixels in index.html only cover the initial load), and
 * subscribe events when Stripe checkout redirects back with ?checkout=success.
 */
const PixelTracker = () => {
    const history = useHistory();

    useEffect(() => {
        if (!isOrdersPath(history.location.pathname)) {
            checkCheckoutSuccess(history, history.location);
        }
        const unlisten = history.listen((location) => {
            if (isOrdersPath(location.pathname)) {
                return;
            }
            if (suppressNextPageView) {
                suppressNextPageView = false;
            } else {
                trackMetaPixelPageView();
                trackAppLovinPageView();
            }
            checkCheckoutSuccess(history, location);
        });
        return () => {
            unlisten();
        };
    }, [history]);

    return null;
};

export default memo(PixelTracker);
